"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ScaleRangeItem {
    constructor(from, to, color) {
        this.from = from;
        this.to = to;
        this.color = color;
        from !== undefined && (this.from = from);
        to !== undefined && (this.to = to);
        color !== undefined && (this.color = color);
    }
    toJsonString() {
        let toJsonData = "";
        toJsonData += "{";
        toJsonData += "\"from\":";
        toJsonData += this.from;
        toJsonData += ",";
        toJsonData += "\"to\":";
        toJsonData += this.to;
        toJsonData += ",";
        toJsonData += "\"color\":\"";
        toJsonData += this.color;
        toJsonData += "\"}";
        return toJsonData;
    }
    fromJson(jsonObject) {
        jsonObject.from !== undefined && (this.from = jsonObject.from);
        jsonObject.to !== undefined && (this.to = jsonObject.to);
        jsonObject.color !== undefined && (this.color = jsonObject.color);
    }
}
exports.ScaleRangeItem = ScaleRangeItem;
//# sourceMappingURL=scale-range-item.model.js.map